/*@ngInject*/
const RuleUtil = function ($rootScope, $uibModal, configurationMediator, coreConstant, loadingBarHandler, localization, uiPerformanceLoggerConstant) {

    this.typeNameToVariableMethodMap = {
        'String': 'stringValue',
        'Boolean': 'booleanValue',
        'Integer': 'intValue',
        'Double': 'doubleValue',
        'Date': 'dateValue'
    };

    this.getRuleSetName = function (rule) {
        if (!_.isNil(rule)) {
            return _.first(_.split(rule.parentPath, '/'));
        }
        return '';
    };

    this.getConditionType = function (objectUri) {
        var type;

        if (objectUri.lastIndexOf('/') > 0) {
            type = objectUri.substr(1, _.lastIndexOf(objectUri, '/') - 1);
        } else {
            type = objectUri.substr(1);
        }
        return type;
    }

    this.getRuleNameSubstring = function (rule) {
        var nameSubstring;

        if (!_.isNil(rule) && !_.isNil(rule.name)) {
            nameSubstring = rule.name.lastIndexOf('-#') !== -1 ? rule.name.substr(0, rule.name.lastIndexOf('-#')) : rule.name;
        }

        return nameSubstring;
    }

    this.updateUiFieldTriggerRuleNames = function (uiFormTemplate, oldTriggerRuleName, newTriggerRuleName) {

        _.each(uiFormTemplate.sections, function (section) {
            _.each(section.rows, function (row) {
                _.each(row.fields, function (field) {
                    if (field.fieldTemplate.triggerRuleName === oldTriggerRuleName) {
                        field.fieldTemplate.triggerRuleName = newTriggerRuleName;
                    }
                });
            });
        });

        _.each(uiFormTemplate.formTemplate.fieldTemplates, function (fieldTemplate) {
            if (fieldTemplate.triggerRuleName === oldTriggerRuleName) {
                fieldTemplate.triggerRuleName = newTriggerRuleName;
            }
        });

    };

    this.cleanUpUiFieldsByTriggerRuleName = function (uiFormTemplate, triggerRuleName) {

        _.each(uiFormTemplate.sections, function (section) {
            _.each(section.rows, function (row) {
                _.each(row.fields, function (field) {
                    if (field.fieldTemplate.triggerRuleName === triggerRuleName) {
                        field.fieldTemplate.triggerRuleName = null;
                        field.fieldTemplate.untriggerBehavior = 0;
                    }
                });
            });
        });

        _.each(uiFormTemplate.formTemplate.fieldTemplates, function (fieldTemplate) {
            if (fieldTemplate.triggerRuleName === triggerRuleName) {
                fieldTemplate.triggerRuleName = null;
                fieldTemplate.untriggerBehavior = 0;
            }
        });

    };

    this.createVariableValueList = function (ruleConditionGroup) {
        var variableValueList = [];

        _.each(ruleConditionGroup.subconditions, function (subcondition) {
            variableValueList = _.concat(variableValueList, this.processVariablesFromCondition(subcondition));
        }.bind(this));

        return variableValueList;
    };

    this.processVariablesFromCondition = function (condition) {
        var variableValueList = [],
            conditionType = this.getConditionType(condition.objectUri);

        if (conditionType === 'CompositeCondition') {
            variableValueList = _.concat(variableValueList, this.createVariableValueList(condition));
        } else if (conditionType === 'UnaryCondition') {
            variableValueList = _.concat(variableValueList, this.processVariablesFromCondition(condition.subcondition, variableValueList));
        } else if (conditionType === 'BinaryCondition') {
            if (condition.lhs && condition.lhs.variableName && !_.startsWith(condition.lhs.objectUri, '/VariableValue')) {
                variableValueList.push({
                    variableName: condition.lhs.variableName,
                    typeName: condition.lhs.typeName,
                    variableMethod: this.typeNameToVariableMethodMap[condition.lhs.typeName]
                });
            }
            if (condition.rhs && condition.rhs.variableName && !_.startsWith(condition.rhs.objectUri, '/VariableValue')) {
                variableValueList.push({
                    variableName: condition.rhs.variableName,
                    typeName: condition.rhs.typeName,
                    variableMethod: this.typeNameToVariableMethodMap[condition.rhs.typeName]
                });
            }
        } else if (conditionType === 'ParameterizedCondition') {
            _.each(condition.parameters, function (parameter) {
                if (parameter.variableName) {
                    variableValueList.push({
                        variableName: parameter.variableName,
                        typeName: parameter.typeName,
                        variableMethod: this.typeNameToVariableMethodMap[parameter.typeName]
                    });
                }
            }.bind(this));
        }

        return variableValueList;
    };

    this.redeployRuleSets = function (defaultRuleSetId) {
        var modalInstance = $uibModal.open({
            templateUrl: '/configuration/rulesBrowser/redeployRuleSets/redeployRuleSets.tpl.html',
            controller: 'redeployRuleSetsController',
            windowClass: 'redeployRuleSetsModal',
            resolve: {
                options: {
                    defaultRuleSetId: defaultRuleSetId
                }
            }
        });

        modalInstance.result.then(function (response) {
            localization.getTranslationByKey('redeployRuleSets').then(function (translations) {
                var logAction = uiPerformanceLoggerConstant.REDEPLOY_RULE_SETS,
                    numRuleSets = !_.isNil(response.ruleSetIds) ? response.ruleSetIds.length : 0,
                    successMessage = _.replace(_.get(translations, 'successMessage'), '{numRuleSets}', numRuleSets),
                    loadingBar = _.replace(_.get(translations, 'loadingBar'), '{numRuleSets}', numRuleSets);

                function onSuccess(response) {
                    loadingBarHandler.concludeNotificationLoadingBar(successMessage);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
                }

                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction);
                loadingBarHandler.showNotificationLoadingBar(loadingBar);
                configurationMediator.redeployRuleSets(response.ruleSetIds).then(onSuccess, onError);
            }.bind(this));
        });
    };
};

angular.module('ums.configuration')
    .service('ruleUtil', RuleUtil);
